export class GdsgDevStats {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "activeWorkers",
            "baseName": "activeWorkers",
            "type": "GdsgActiveWorkers",
            "format": ""
        },
        {
            "name": "workerRegistry",
            "baseName": "workerRegistry",
            "type": "Array<GdsgRegisteredWorker>",
            "format": ""
        },
        {
            "name": "bigtable",
            "baseName": "bigtable",
            "type": "GdsgBigtableClusterStats",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GdsgDevStats.attributeTypeMap;
    }
    constructor() {
    }
}
